export function pipeQueryString(queryKey: string, queryValue?: string | number, isFirst = false) {
  return (url: string) =>
    queryValue ? `${url}${!isFirst ? '&' : ''}${queryKey}=${encodeURIComponent(queryValue)}` : url;
}
